"use strict";

(function () {
  'use strict';

  angular.module('lr.Timeline').directive('lrTimeline', ['EventSettingsFactory', '$filter', function (EventSettingsFactory, $filter) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        events: '=',
        config: '=',
        load: '=',
        limit: '@'
      },
      link: function link(scope) {
        var page;

        if (scope.config.page !== undefined) {
          page = scope.config.page;
        } else {
          page = 0;
        }
        /* function init() {
             if (scope.config.delay) {
             return;
           }
             if (typeof scope.load === 'function') {
             page++;
             scope.load(page);
           }
             console.log(scope.load);
         }*/

        /* scope.$watch(scope.load, function (o) {
             init();
           });*/

        /*if (scope.events) {
         scope.events = $filter('eventsFilter')([scope.events], EventSettingsFactory.eventFilters);
         }*/


        scope.loadMore = function () {
          page++;
          scope.load(page);
        };
      },
      templateUrl: 'app/components/timeline/lr-timeline.html'
    };
  }]);
  angular.module('lr.Timeline').directive('lrTimelineEle', lrTimelineEle);

  function lrTimelineEle() {
    return {
      restrict: 'EA',
      scope: {
        data: '='
      },
      controller: lrTimelineEleCtrl,
      link: function link(scope, element, attrs) {},
      templateUrl: 'app/components/timeline/lr-timeline-ele.html'
    };
  }

  lrTimelineEleCtrl.$inject = [];
  /* @ngInject */

  function lrTimelineEleCtrl() {}
})();